import { useState } from 'react';
import { Box } from '@mui/material';
import { brandLogoUrl } from 'features/brand/brandLogoUrl';
import { useColorMode } from 'features/theme/useColorMode';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = {
  sx?: SxProps<Theme>;
};

/** The active brand's logo (alt = sponsor name); nothing without one or after
 *  a load error. `sx` is merged after the logo's own styles. */
export const SponsorLogo = ({ sx }: Props) => {
  const { activeBrand } = useColorMode();
  const logoUrl = brandLogoUrl(activeBrand);
  const [failedUrl, setFailedUrl] = useState<string | undefined>(undefined);

  if (!activeBrand || !logoUrl || failedUrl === logoUrl) return null;

  return (
    <Box
      component="img"
      src={logoUrl}
      alt={activeBrand.sponsorName}
      onError={() => setFailedUrl(logoUrl)}
      sx={[
        {
          height: { xs: 24, sm: 28 },
          maxWidth: 140,
          objectFit: 'contain',
          display: 'block',
        },
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- SxProps array spread is safe; MUI's type lacks the index signature that would allow it
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};
